import {
  UI_COLOR_BORDER_DISABLED,
  UI_COLOR_BORDER_LIGHT,
  UI_COLOR_PRIMARY,
  UI_COLOR_RBAC_STATUS_ACTIVE_BG,
  UI_COLOR_RBAC_STATUS_ACTIVE_TEXT,
  UI_COLOR_RBAC_STATUS_INACTIVE_BG,
  UI_COLOR_RBAC_STATUS_INACTIVE_TEXT,
  UI_COLOR_SURFACE_READONLY,
  UI_COLOR_TEXT_HEADING,
  UI_COLOR_TEXT_MUTED_LIGHT,
  UI_COLOR_TEXT_READONLY,
  UI_COLOR_TEXT_SUBTITLE,
  UI_COLOR_WHITE
} from '../../../../constants/uiColors'

export const PROFILE_INFO_COPY = {
  title: 'Información general',
  nameRequired: 'El nombre es requerido.',
  updateSuccess: 'Perfil actualizado.',
  updateError: 'No fue posible guardar.',
  emptyValue: '—',
  noRole: 'Sin rol'
}

export const PROFILE_INFO_STATUS_META = {
  active: {
    label: 'ACTIVO',
    backgroundColor: UI_COLOR_RBAC_STATUS_ACTIVE_BG,
    color: UI_COLOR_RBAC_STATUS_ACTIVE_TEXT
  },
  inactive: {
    label: 'INACTIVO',
    backgroundColor: UI_COLOR_RBAC_STATUS_INACTIVE_BG,
    color: UI_COLOR_RBAC_STATUS_INACTIVE_TEXT
  },
  pending: {
    label: 'PENDIENTE',
    backgroundColor: '#FFF4E5',
    color: '#B26A00'
  }
}

export const profileInfoCardSx = {
  bgcolor: UI_COLOR_WHITE,
  border: `1px solid ${UI_COLOR_BORDER_LIGHT}`,
  borderRadius: '16px',
  overflow: 'hidden'
}

export const profileInfoHeaderSx = {
  display: 'flex',
  alignItems: { xs: 'flex-start', sm: 'center' },
  justifyContent: 'space-between',
  gap: 2,
  px: { xs: 2, sm: 2.5 },
  py: 1.75
}

export const profileInfoTitleSx = {
  fontSize: 15,
  fontWeight: 800,
  color: UI_COLOR_TEXT_HEADING
}

export const profileInfoSummaryRowSx = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: { xs: 2, sm: 3 },
  mb: 2
}

export const profileInfoSummaryLabelSx = {
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '0.04em',
  color: UI_COLOR_TEXT_SUBTITLE,
  textTransform: 'uppercase'
}

export const profileInfoSummaryDividerSx = {
  display: { xs: 'none', sm: 'block' },
  width: '1px',
  height: 18,
  bgcolor: UI_COLOR_BORDER_LIGHT
}

export const profileInfoContentGridSx = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
  gap: 1.5
}

export const profileInfoDetailBlockSx = {
  p: { xs: 1.5, sm: 1.75 },
  border: `1px solid ${UI_COLOR_BORDER_LIGHT}`,
  borderRadius: '14px',
  bgcolor: UI_COLOR_WHITE
}

export const profileInfoDetailLabelSx = {
  mb: 0.9,
  fontSize: 12,
  fontWeight: 800,
  letterSpacing: '0.02em',
  color: UI_COLOR_TEXT_SUBTITLE,
  textTransform: 'uppercase'
}

export const profileInfoFieldSx = {
  '& .MuiInputLabel-root': {
    fontSize: 13,
    color: UI_COLOR_TEXT_SUBTITLE
  },
  '& .MuiOutlinedInput-root': {
    bgcolor: UI_COLOR_WHITE,
    borderRadius: '12px',
    minHeight: 44,
    '& fieldset': {
      borderColor: UI_COLOR_BORDER_LIGHT
    },
    '&:hover fieldset': {
      borderColor: UI_COLOR_PRIMARY
    },
    '&.Mui-focused fieldset': {
      borderColor: UI_COLOR_PRIMARY
    }
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: UI_COLOR_TEXT_HEADING,
    opacity: 0.8
  }
}

export const profileInfoReadOnlyFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    minHeight: 44,
    overflow: 'hidden',
    bgcolor: UI_COLOR_SURFACE_READONLY,
    border: `1px solid ${UI_COLOR_BORDER_DISABLED}`,
    '& fieldset': {
      display: 'none'
    },
    '&.Mui-disabled': {
      bgcolor: UI_COLOR_SURFACE_READONLY
    }
  },
  '& .MuiInputBase-input': {
    backgroundColor: 'transparent'
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: UI_COLOR_TEXT_READONLY,
    opacity: 1,
    fontSize: 14,
    fontWeight: 600,
    backgroundColor: 'transparent'
  }
}

export const profileInfoReadOnlyEmptyFieldSx = {
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: UI_COLOR_TEXT_MUTED_LIGHT,
    opacity: 1,
    fontSize: 14,
    fontWeight: 600
  }
}
